import dayjs from 'dayjs';
import groupBy from 'lodash-es/groupBy';
import reverse from 'lodash-es/reverse';
import sortBy from 'lodash-es/sortBy';
const sortEvents = (events) => reverse(sortBy(events, ['happenedAt']));
export const getSections = (events) => {
    const sortedEvents = sortEvents(events);
    return groupBy(sortedEvents, ({ happenedAt }) => happenedAt && dayjs(happenedAt).format('MM DD YY'));
};
